import { useEffect } from "react";
import { useFormikContext } from "formik";

export default function AttachmentWatcher({ attachmentCount }) {
  const { setFieldTouched, setFieldError } = useFormikContext();

  useEffect(() => {
    if (attachmentCount > 0) {
      setFieldTouched("osdImage", false);
      setFieldError("osdImage", undefined);
    }
  }, [attachmentCount, setFieldTouched, setFieldError]);

  return null;
}

